import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import SummaryApi from "../common";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);

  const getUserId = () => {
    const sessionData = localStorage.getItem("user");
    if (!sessionData) return null;
    try {
      const parsed = JSON.parse(sessionData);
      return parsed.user_id || parsed.id || parsed;
    } catch { return sessionData; }
  };

  const fetchCartCount = useCallback(async () => {
    const userId = getUserId();

    if (!userId) {
      // Guest logic
      const guestData = sessionStorage.getItem("guest_cart");
      if (guestData) {
        const parsed = JSON.parse(guestData);
        // SUM quantities instead of counting array length
        const totalQuantity = parsed.reduce((acc, item) => acc + (Number(item.quantity) || 0), 0);
        setCartCount(totalQuantity);
      } else {
        setCartCount(0);
      }
      return;
    }

    // Logged in user logic
    try {
      const res = await fetch(SummaryApi.getCartById.url, {
        method: SummaryApi.getCartById.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: userId }),
      });
      const result = await res.json();
      if (result.status && result.data) {
        // SUM quantities instead of counting array length
        const totalQuantity = result.data.reduce((acc, item) => acc + (Number(item.quantity) || 0), 0);
        setCartCount(totalQuantity);
      } else {
        setCartCount(0);
      }
    } catch (err) {
      console.error("Cart fetch error:", err);
    }
  }, []);

  useEffect(() => {
    fetchCartCount();
  }, [fetchCartCount]);

  return (
    <CartContext.Provider value={{ cartCount, fetchCartCount }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);